import { ENV } from '../config/env';

export const resolveFileUrl = (value?: string | null) => {
  if (!value) return '';
  const trimmed = String(value).trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const apiBase = typeof ENV.API_URL === 'string'
    ? ENV.API_URL.replace(/\/api\/?$/, '')
    : '';

  if (!apiBase) return trimmed;
  if (trimmed.startsWith('/public/')) return `${apiBase}${trimmed}`;
  if (trimmed.startsWith('public/')) return `${apiBase}/${trimmed}`;

  return `${apiBase}/${trimmed.replace(/^\/+/g, '')}`;
};
